module.exports = __webpack_public_path__ + "img/14.28223b43.png";